import React from "react";
import { apiEndpoints } from "../../config";

// Modules
import PostAdd from "../../partials/posts/postAdd";

export default function AddCompanyDirectory(props) {
  return(
    <PostAdd 
      targetVid={"company_directory_categories"}
      addPostEndpoint={apiEndpoints.company_directory}
      editRoute={"/company_directory/edit"}
      entityType={"company_directory"}
      pageTitle={"Create a Company Directory post"}
      returnRoute={"/company_directory-creator"}
      categoryName={"company_directory"}
    />
  )
}
